import SiteWrapper from '../client/components/SiteWrapper'
import {learnvestApi} from '../client/api/learnvest'
import {makeStore} from '../client/redux'
import ErrorPage from 'pages/ErrorPage'
import React from 'react'
import withRedux from 'next-redux-wrapper'
import {handleApiUnavailableError} from '../client/utils/errors'

class ErrorWrapper extends React.Component {
  static async getInitialProps ({res, store}) {
    const statusCode = res ? res.statusCode : 404
    const serverError = {statusCode}
    try {
      await learnvestApi.cms(store)
      return serverError
    } catch (e) {
      return Object.assign(serverError, handleApiUnavailableError(e))
    }
  }

  render () {
    const serverError = this.props.statusCode
    return (
      <SiteWrapper includeNewsletterPromo={false}>
        <ErrorPage errorCode={serverError} />
      </SiteWrapper>
    )
  }
}

export default withRedux(makeStore)(ErrorWrapper)



// WEBPACK FOOTER //
// ./pages/_error.js